<template>
  <AnablueSidebar
    data-v-step="sidebar"
    :items="navItems"
    :minimize="$store.state.sidebarMinimize"
    @update:minimize="
      (value) => $store.commit('set', ['sidebarMinimize', value])
    "
  />
</template>

<script>
import { getSidebarNav } from "./_nav";
import { ActiveUser } from "@/services/user";
import { IS_DEV } from "@/constants/config";

export default {
  name: "TheSidebar",
  computed: {
    navItems() {
      return getSidebarNav(
        ActiveUser.isAdministrator(),
        this.$route.params?.entity_id,
        this.$store.state?.quarter,
      );
    },
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
  },
};
</script>
